import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class SmsSettings extends Component {
  render() {
    return (
      <section>
        <p>SMS</p>
      </section>
    );
  }
}

SmsSettings.propTypes = {};

export default translate(SmsSettings);
